module.exports = __webpack_public_path__ + "media/music/jazzy_bass_6-3afc594a.mp3";